/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef , useContext } from "react";
import { APIEndpoint } from "../../../utils/axios";
import {
  DataGrid,
  EditModal,
  NGODatePicker,
  ConfirmModal,
  SpreadsheetModal,
  Modal,
} from "../../../common";
import {
  formatDateByTimezone,
  doTooltipFirstLetterCaps,
  getCultureFromLs,
  getTimeZoneAbbreviation,
  storageUtil,
  calculateTextWidth,
  parseJwtToken
} from "../../../utils/commonFunctions";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import viewIcon from "../../../assets/view.svg";
import Edit2 from "../../../assets/edit2.svg";
import moment from "moment-timezone";
import searchIcon from "../../../assets/icons/search.svg";
import * as ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import usePermissions from "../../../utils/userPermissions";
import { customSelSearch } from "../../../utils/configs";
import CustomSelect from "../../../common/CustomSelect";
import { FaPersonCircleCheck } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { FaPersonChalkboard } from "react-icons/fa6";
import { IoBarcodeOutline } from "react-icons/io5";
import downloadMasterIcon from "../../../assets/icons/download-master.svg";
import {SectorRenderer} from "../../sales/inner-components/renderers";
import { RetrievalVarianceReportDownload } from "../../../common/RetrievalVarianceReportDownload";
import {ThemeContext} from '../../../contexts/themeContext';

const toastError = (msg) => {
  toast.dismiss();
  toast.error(msg, {
    position: "top-center",
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: false,
    autoClose: 3800,
    style: {
      backgroundColor: "#d9534f",
      color: "#fff",
      borderRadius: "8px",
      fontSize: "0.95rem",
      minWidth: "28rem",
    },
  });
};

const toastSuccess = (msg) => {
  toast.dismiss();
  toast.success(msg, {
    position: "top-center",
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: false,
    autoClose: 3000,
    style: {
      backgroundColor: "#4cae4c",
      color: "#fff",
      borderRadius: "8px",
      fontSize: "0.95rem",
      minWidth: "28rem",
    },
  });
};

const ReconState = [
  { key: 0, label: "Draft", value: "draft" },
  { key: 1, label: "Finalized", value: "finalized" },
];

const EditTransferColumns = [
  {
    label: "Item Code",
    type: "select",
    labelProp: "itemCode",
    attribute: "itemCode",
    required: true,
  },
  {
    label: "Item Name",
    type: "select",
    labelProp: "itemName",
    attribute: "itemName",
    required: true,
  },
  { label: "Unit", type: "string", attribute: "unit", required: true },
  {
    label: "Actual Offload",
    type: "number",
    attribute: "actualOffload",
    required: true,
  },
  { label: "Damage", type: "number", attribute: "damage", required: false },
  { label: "Wastage", type: "number", attribute: "wastage", required: false },
  { label: "Expired", type: "number", attribute: "expired", required: false },
  { label: "Lost", type: "number", attribute: "lost", required: false },
  {
    label: "Back To Warehouse",
    type: "number",
    attribute: "backToWarehouse",
    required: false,
  },
  { label: "Remarks", type: "string", attribute: "remarks", required: false },
];
const RecocniliationView = [
  {
    field: "itemCode",
    headerName: "Item Code",
    tooltipField: "itemCode",
    flex: 1,
    cellStyle: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    suppressSizeToFit: true,
    resizable: true,
    minWidth: 150,
  },
  {
    field: "itemName",
    headerName: "Item Name",
    flex: 1,
    suppressSizeToFit: true,
    resizable: true,
    minWidth: 200,
    tooltipField: "itemName",
    cellStyle: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  {
    field: "unit",
    headerName: "Unit",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "totalOffloaded",
    headerName: "Offloaded",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "totalUnloaded",
    headerName: "Unloaded",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "actualOffload",
    headerName: "Actual Offload",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "damage",
    headerName: "Damage",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "wastage",
    headerName: "Wastage",
    flex: 1,
    minWidth: 100,
    suppressSizeToFit: true,
  },
  {
    field: "expired",
    headerName: "Expired",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "lost",
    headerName: "Lost",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "backToWarehouse",
    headerName: "Back To Warehouse",
    flex: 1,
    suppressSizeToFit: true,
    minWidth: 100,
  },
  {
    field: "remarks",
    headerName: "Remarks",
    flex: 1,
    cellStyle: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    suppressSizeToFit: true,
    resizable: true,
    minWidth: 125,
  },
];

const emptyFields = [{ value: null }];

export const Reconciliations = (props) => {
  const { t, ready } = useTranslation();

  const tableRef = useRef();
  const filtersRef = useRef(null);

  const { viewOnly, groupDetails } = props;
  let updatedEditFields = [];
  const [state, setState] = useState({ showLoadingApi: false });
  const navigate = useNavigate();
  const [editFormFields, setEditFormFields] = useState(null);
  const [isLoadingCateringGroupsSelect, setIsLoadingCateringGroupsSelect] =
    useState(false);
  const [sectorsMap, setSectorsMap] = useState(new Map());
    const [width, setwidth] = useState('12.5rem');
  const [perPageLimit, setPerPageLimit] = useState(50);
  const [searchKey, setSearchKey] = useState("");
  const [date, setDate] = useState(
    viewOnly
      ? new Date(formatDateByTimezone(props.groupDetails?.startTime))
      : formatDateByTimezone(storageUtil.get("date", "session"))
      ? new Date(formatDateByTimezone(storageUtil.get("date", "session")))
      : new Date()
  );
  const [dateRange] = useState({
    minDate: viewOnly
      ? (() => {
          const d = new Date(formatDateByTimezone(groupDetails.startTime));
          d.setDate(d.getDate() - 1);
          return d;
        })()
      : null,
    maxDate: viewOnly
      ? (() => {
          const d = new Date(formatDateByTimezone(groupDetails.startTime));
          d.setDate(d.getDate() + 1);
          return d;
        })()
      : null,
  });
  const [storesList, setStoresList] = useState([]);
  const [items, setItems] = useState([]);
  const [editSheetTitle, setEditSheetTitle] = useState(null);
  const [EditFieldsCess, setEditFieldsCess] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalCustomButtons, setModalCustomButtons] = useState([]);
  const [warehouseArray, setWareHouseArray] = useState([]);
  const [warehouseArr, setWareHouseArr] = useState([]);
  const [reconState, setReconstate] = useState([]);
  const [reconStateSel, setReconstateSel] = useState(
    storageUtil.get("reconStateSel", "session") || null
  );
  const [updatedFormFieldValues, setUpdatedFormFieldValues] = useState({});
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: "" });
  const [wareHouseSel, setWarehouseSel] = useState("");
  const [wareHouseSelSearch, setWarehouseSelSearch] = useState([]);
  const [storeSelSearch, setStoreSelSearch] = useState([]);
  const [storeSelect, setStoreSelect] = useState([]);
  const [storeArray, setStoreArray] = useState([]);
  const [storeId, setStoreId] = useState(
    storageUtil.get("storeId", "session") || null
  );
  const [modalFormData, setModalFormData] = useState({});
  const [wStoreId, setWStoreId] = useState(
    !viewOnly
      ? storageUtil.get("wStoreId", "session") || null
      : groupDetails.warehouse.warehouseId ?? null
  );
  const [gridReset, setGridReset] = useState(false);
  const [cateringGroupOptions, setCateringGroupOptions] = useState([]);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [retrievalUploadState, setRetrievalUploadState] = useState({
  downloading: false,
  uploading: false,
});
const [retrievalImportError, setRetrievalImportError] = useState({
  open: false,
  errors: [],
  message: "",
});

const getHeaders = async () => {
  const storedCreds = localStorage.getItem("login_credentials");
  if (!storedCreds) return null;
  const { data: creds } = JSON.parse(storedCreds) || {};
  const tokenResp = await parseJwtToken(creds);
  if (!tokenResp?.userId) return null;
  return { user_id: tokenResp.userId };
};

function RetrievalImportErrorModal({ open, errors, message, onClose }) {
  if (!open) return null;
  return (
    <div
      className="modal-overlay"
      style={{ animation:"none", transition:"none" }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div
        className="modal-box"
        style={{
          width:580,
          maxHeight:"80vh",
          overflowY:"auto",
          animation:"none",
          transition:"none",
          background:"#0d1628",
          border:"1px solid rgba(40,80,140,0.55)",
          borderRadius:12,
        }}
      >
        <div
          className="modal-header"
          style={{
            padding:"18px 24px",
            borderBottom:"1px solid rgba(40,80,140,0.55)",
          }}
        >
          <div>
            <div className="modal-title" style={{ display:"flex", alignItems:"center", gap:8, color:"#4cc3e6" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#e05c5c" strokeWidth="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              Retrieval Upload Failed
            </div>
            <div className="modal-subtitle" style={{ color:"#8aaacf" }}>
              {message || "Please fix the following errors and re-upload."}
            </div>
          </div>
          <button className="modal-close" onClick={onClose} style={{ color:"#3d5a7a" }}>×</button>
        </div>
        <div className="modal-body" style={{ padding:"22px 24px" }}>
          <div>
            <table className="catering-table-main" style={{ width:"100%", borderCollapse:"collapse", fontSize:13, background:"#0d1628" }}>
              <thead>
                <tr style={{ background:"rgba(224,92,92,0.1)" }}>
                  <th style={{ padding:"8px 14px", textAlign:"left", color:"#8aaacf", fontWeight:600, fontSize:11, textTransform:"uppercase", letterSpacing:"0.05em", width:80 }}>Line</th>
                  <th style={{ padding:"8px 14px", textAlign:"left", color:"#8aaacf", fontWeight:600, fontSize:11, textTransform:"uppercase", letterSpacing:"0.05em" }}>Error</th>
                </tr>
              </thead>
              <tbody>
                {(errors || []).map((row, i) => (
                  <tr key={i} style={{ borderTop:"1px solid rgba(40,80,140,0.3)", background: i % 2 === 0 ? "#0d1628" : "rgba(13,22,40,0.4)" }}>
                    <td style={{ padding:"10px 14px", verticalAlign:"top" }}>
                      <span style={{ display:"inline-block", padding:"2px 8px", borderRadius:6, background:"rgba(224,92,92,0.15)", color:"#e05c5c", fontFamily:"monospace", fontSize:12, fontWeight:600 }}>
                        {row.lineNumber === "All" ? "All" : `#${row.lineNumber}`}
                      </span>
                    </td>
                    <td style={{ padding:"10px 14px", verticalAlign:"top" }}>
                      {row.errors.map((e, j) => (
                        <div key={j} style={{ color:"#c8daea", lineHeight:1.6 }}>
                          {row.errors.length > 1 && <span style={{ color:"#3d5a7a", marginRight:6 }}>·</span>}
                          {e.message}
                        </div>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div
          className="modal-footer"
          style={{
            display:"flex",
            justifyContent:"flex-end",
            padding:"14px 24px",
            borderTop:"1px solid rgba(40,80,140,0.55)",
          }}
        >
          <button className="btn btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

const downloadRetrievalTemplate = async (row) => {
  const { warehouseId, id, code } = row;
  setRetrievalUploadState((s) => ({ ...s, downloading: true }));
  try {
    const hdrs = await getHeaders();
    if (!hdrs) {
      toastError("Unable to authenticate. Please refresh and try again.");
      return;
    }
    const header = {
      ...APIEndpoint.getHeaders().headers,
      user_id: hdrs.user_id,
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };
    const res = await fetch(
      APIEndpoint.getFullPath(
        `warehouses/${warehouseId}/manualRecons/${id}/retrieval/template`
      ),
      { method: "GET", headers: header }
    );
    if (!res.ok) {
      const errJson = await res.json().catch(() => null);
      toastError(errJson?.message || "Failed to download retrieval template.");
      return;
    }
    const blob = await res.blob();
    saveAs(blob, `retrieval-template-${code || id}.xlsx`);
  } catch (err) {
    console.error("downloadRetrievalTemplate error:", err);
    toastError("Failed to download retrieval template.");
  } finally {
    setRetrievalUploadState((s) => ({ ...s, downloading: false }));
  }
};

const uploadRetrieval = (row) => {
  const { warehouseId, id } = row;
  const input = document.createElement("input");
  input.type = "file";
  input.accept = ".xlsx,.xls";
  input.onchange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setRetrievalUploadState((s) => ({ ...s, uploading: true }));
    try {
      const hdrs = await getHeaders();
      if (!hdrs) {
        toastError("Unable to authenticate. Please refresh and try again.");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const header = {
        user_id: hdrs.user_id,
        "Content-Type": "multipart/form-data",
      };
      const res = await APIEndpoint.post(
        `warehouses/${warehouseId}/manualRecons/${id}/retrieval/upload`,
        formData,
        header
      );
      if (res?.success) {
        toastSuccess(res.message || "Retrieval recorded successfully.");
      } else if (res?.errors?.length) {
        setRetrievalImportError({
          open: true,
          errors: res.errors,
          message: res.message,
        });
      } else {
        toastError(res?.message || "Upload failed.");
      }
    } catch (err) {
      console.error("uploadRetrieval error:", err);
      try {
        const errorObj = JSON.parse(err.message);
        if (errorObj?.data?.errors?.length) {
          setRetrievalImportError({
            open: true,
            errors: errorObj.data.errors,
            message: errorObj.data.message,
          });
        } else {
          toastError(errorObj?.data?.message || "Upload failed.");
        }
      } catch {
        toastError("Upload failed. Please try again.");
      }
    } finally {
      setRetrievalUploadState((s) => ({ ...s, uploading: false }));
    }
  };
  input.click();
};

    const {themedColor} = useContext(ThemeContext);

  const SectorsCellRenderer = (dataMain) => {
const {createdBy}=dataMain?.data || {};

     if(createdBy){
      return (
        <div className='flexRow justifyContentSpaceBetween'  style={{width:'100%',maxWidth:'225px',overflow:'auto'}}>
        <div className={`sector-container justifyContentFlexStart alignItemsCenter`} style={{marginRight:'1.5rem',maxWidth:'auto'}}>
          <span className="uplift-user" style={{width:'200px'}}>{createdBy && createdBy?.employeeCode !== createdBy?.employeeName ?`${createdBy?.employeeCode} -`:null} {createdBy?.employeeName??""}</span>
        </div>
      </div>
        )
    }else{
     return null;
    }


  };
  const { hasPermission: viewReconciliations } = usePermissions(
    "viewDetails",
    "orn:Warehouse:ManageReconciliation"
  );
  const { hasPermission: approveReconciliations } = usePermissions(
    "approve",
    "orn:Warehouse:ManageReconciliation"
  );
  const { hasPermission: saveReconciliation } = usePermissions(
    "save",
    "orn:Warehouse:ManageReconciliation"
  );
  const { hasPermission: createReconciliation } = usePermissions(
    "create",
    "orn:Warehouse:ManageReconciliation"
  );
  const { hasPermission: editReconciliations } = usePermissions(
    "edit",
    "orn:Warehouse:ManageReconciliation"
  );
  const { hasPermission: deleteReconciliation } = usePermissions(
    "delete",
    "orn:Warehouse:ManageReconciliation"
  );

  const { hasPermission: downloadRetrievalVarianceReport } = usePermissions(
    "download",
    "orn:Warehouse:ManageReconciliation"
  );

  let reconStateCreate = { warehouse: "", store: "", date: "" };
  const Columns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      suppressSizeToFit: true,
      resizable: true,
      tooltipField: "code",
      minWidth: 270,
    },
    {
      field: "warehouseName",
      headerName: "Warehouse",
      valueGetter: (params) => {
        const c = params.data?.warehouseName;
        if (!c) return null;
        const parts = c.trim().split(" ");
        if (parts.length > 0) {
          const lastWord = parts[parts.length - 1].toLowerCase();
          return lastWord.includes("warehouse")
            ? parts.slice(0, -1).join(" ")
            : c;
        }
        return c;
      },
      flex: 1,
      suppressSizeToFit: true,
      resizable: true,
      minWidth: 160,
      tooltipField: "warehouseName",
    },
    {
      field: "",
      headerName: "Sector",
       cellRendererSelector: () => {
            return {
              component: SectorRenderer,
            };
          },
      suppressSizeToFit: true,
      flex: 1,
      resizable: true,
      minWidth: 160,
      tooltipField: "sector",
    },
    {
      field: "operationDate",
      headerName: "Operation Date",
      valueGetter: (params) => {
        return params.data?.operationDate
          ? moment
              .parseZone(formatDateByTimezone(params.data?.operationDate))
              .format("DD-MM-YYYY")
          : "";
      },
      filter: true,
      suppressSizeToFit: true,
      flex: 1,
      minWidth: 140,
    },

    {
      field: "flightDate",
      headerName: "Flight Date",
      valueGetter: (params) => {
        return params.data?.flightDate
          ? moment
              .parseZone(formatDateByTimezone(params.data?.flightDate))
              .format("DD-MM-YYYY")
          : "";
      },
      filter: true,
      suppressSizeToFit: true,
      flex: 1,
      minWidth: 140,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      cellRendererFramework: (params) => (
        <SectorsCellRenderer
          {...params}
          headerName={params.data?.createdBy}
        />
      ),

      suppressSizeToFit: true,
      flex: 1,
      resizable: true,
      filter: true,
      minWidth: 230,
    },
    {
      field: "createdAt",
      headerName: "Created At",
       valueGetter: params => {
                      return params.data?.createdAt ? moment(params.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
                  },
      suppressSizeToFit: true,
      flex: 1,
      minWidth: 180,
    },
    {
      field: "state",
      headerName: "State",
      valueGetter: (params) => {
        return params.data
          ? params.data.state[0].toUpperCase() + params.data.state.substring(1)
          : "";
      },
      suppressSizeToFit: true,
      flex: 1,
      minWidth: 80,
    },
    {
      field: "progress",
      headerName: "Progress",
      valueGetter: (params) => {
        return params.data
          ? params.data.progress[0].toUpperCase() +
              params.data.progress.substring(1)
          : "";
      },
      suppressSizeToFit: true,
      flex: 1,
      minWidth: 110,
      tooltipField: "progress",
      tooltipComponent: doTooltipFirstLetterCaps,
    },
    {
      headerName: !viewOnly ? "Actions" : "",
      width: !viewOnly ? 190 : undefined,
      maxWidth: !viewOnly ? 210 : undefined,
      resizable: !viewOnly,
      flex: 1,
      cellRenderer: !viewOnly ? ActionCell : undefined,
      pinned: !viewOnly ? "right" : undefined,
    },
  ];

  function getUpliftRunningIcons(dta, cState) {
    switch (cState) {
      case "reconCreated":
        return (
          <>
            <span
              title="Scan Items"
              onClick={(e) => onAction(e, { value: "ScanInventory" }, dta)}
            >
              <IoBarcodeOutline size={20} className="scanqr-uplift" />
            </span>
            <span
              title="Request Confirmation"
              onClick={(e) => onAction(e, { value: "reviewRequested" }, dta)}
            >
              <FaPersonCircleCheck size={20} className="scanqr-uplift" />
            </span>
          </>
        );
      case "reviewRequestedFromWarehouseOfficer":
        return (
          <>
            <span
              title="Scan Items"
              onClick={(e) => onAction(e, { value: "ScanInventory" }, dta)}
            >
              <IoBarcodeOutline size={20} className="scanqr-uplift" />
            </span>
            {approveReconciliations ? (
              <span
                title="Review Request"
                onClick={(e) =>
                  onAction(e, { value: "requestWarehouseOfficerReview" }, dta)
                }
              >
                <GrUserManager size={20} className="scanqr-uplift" />
              </span>
            ) : null}
          </>
        );

      case "awaitingConfirmationByCateringManager":
        return (
          <>
            <span
              title="Finalize"
              onClick={(e) =>
                onAction(e, { value: "awaitCatManagerConfirmation" }, dta)
              }
            >
              <FaPersonChalkboard size={20} className="scanqr-uplift" />
            </span>
          </>
        );
      case "awaitingItemProcessingAndLoading":
        return (
          <>
            {/* <img className="edit mx-2" alt='items' title="Confirm" src={confirmIcon} onClick={(e) => onAction(dta,'ConfirmItem')}/> */}
            <span
              title="Scan Items"
              onClick={(e) => onAction(e, { value: "ScanInventory" }, dta)}
            >
              <IoBarcodeOutline size={20} className="scanqr-uplift" />
            </span>
          </>
        );

      default:
        return null;
    }
  }

  function ActionCell(props) {
    if (!props?.data) return null;
    return (
      <div className="flexRow justifyContentSpaceBetween">
        {(() => {
          if (props?.data?.state === "finalized") {
  return (
    <div className="flexRow justifyContentFlexStart">
      <button title="View Retrieval" className="margRight30">
        <img
          width={20}
          src={viewIcon}
          alt="View"
          onClick={(e) =>
            onAction(e, { value: "View Reconciliation" }, props.data)
          }
        />
      </button>
      <button
        title="Download Retrieval Template"
        className="margRight30"
        disabled={retrievalUploadState.downloading}
        onClick={() => downloadRetrievalTemplate(props.data)}
      >
        <img className="icon-size-min" alt="Download Template" src={downloadMasterIcon} />
      </button>
      <button
        title="Upload Retrieval"
        disabled={retrievalUploadState.uploading}
        onClick={() => uploadRetrieval(props.data)}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
      </button>
    </div>
  );
}
          
          else if (props?.data?.state === "draft") {
            const { currentState } = props.data.workflow || {
              currentState: null,
            };

            return (
              <div className="flexRow justifyContentFlexStart">
                <button title="Edit Retrieval" className="margRight30">
                  <img
                    width={20}
                    src={Edit2}
                    alt="Edit"
                    onClick={(e) =>
                      onAction(e, { value: "Edit Reconciliation" }, props.data)
                    }
                  />
                </button>
                {getUpliftRunningIcons(props.data, currentState)}
              </div>
            );
          } else {
            return null;
          }
        })()}
      </div>
    );
  }

  const sectorTitle = () => {
    const { action, data } = state.selected;
    if (action === "viewReconciliation" && data) {
      return (
        <div className="flexRow justifyContentCenter">
          <div className="flexRow">
            <div className="flexRow">
              Retrieval -{" "}
              <div className="instance-member-name">{data.code}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    if (viewOnly) {
      storageUtil.clear("date", "session");
      storageUtil.clear("reconStateSel", "session");
      storageUtil.clear("storeId", "session");
      storageUtil.clear("wStoreId", "session");
    }
    return () => {
      filtersRef.current = false;
      if (viewOnly) {
        storageUtil.clear("date", "session");
        storageUtil.clear("reconStateSel", "session");
        storageUtil.clear("storeId", "session");
        storageUtil.clear("wStoreId", "session");
      }
    };
  }, [viewOnly]);

  const AddReconciliationField = [
    {
      key: 1,
      label: "Warehouse ",
      name: "warehouseName",
      id: "warehouseName",
      attribute: "warehouseName",
      type: "selectSearch2",
      defaultValue: "",
      width,
      value: "",
      className: "select-search-cls",
      options: [],
      multiple: false,
      search: true,
      autoComplete: "on",
      autoFocus: false,
      disabled: false,
      placeholder: "Select Warehouse",
      required: true,
    },
    {
      label: `Operation Date * (in ${getTimeZoneAbbreviation(
        getCultureFromLs()?.timezone
      )})`,
      tooltip: "Operation date of the catering group",
      attribute: "operationDate",
      type: "date",
      width,
      maxDate: new Date(),
      disabled: false,
    },
    {
      key: 2,
      label: "Catering Group ",
      name: "cateringGroup",
      id: "cateringGroup",
      attribute: "cateringGroup",
      type: "selectSearch2",
      defaultValue: "",
      width,
      value: "",
      className: "select-search-cls",
      options: [],
      optionsLoading: isLoadingCateringGroupsSelect,
      multiple: false,
      search: true,
      autoComplete: "on",
      autoFocus: false,
      isClearable: true,
      disabled: true,
      placeholder: "Select Catering Group",
      required: true,
    },

    {
      key: 3,
      label: "Sector ",
      name: "sector",
      id: "sector",
      attribute: "sector",
      type: "selectSearch2",
      width,
      defaultValue: "",
      value: "",
      className: "select-search-cls",
      options: [],
      multiple: false,
      search: true,
      autoComplete: "on",
      autoFocus: false,
      disabled: false,
      placeholder: "Select Sector",
      required: true,
    },
    {
      label: `Flight Date * (in ${getTimeZoneAbbreviation(
        getCultureFromLs()?.timezone
      )})`,
      tooltip: "Flight date of the incoming sector",
      attribute: "flightDate",
      width,
      type: "date",
      maxDate: new Date(),
      disabled: false,
    },
  ];

  const preCompile = {
    itemType: t("selectButtons.selSector"),
    flightTime: t("selectButtons.selFlightTime"),
    reconStates: t("selectButtons.selState"),
    warehouses: t("selectButtons.selWarehouse"),
  };

  const updateEditFormValues = async (e, updatedFormObj, type = "") => {
  
    setModalFormStatusObj({ text: "" });
    ReactDOM.flushSync(() => {
      if (!(e || type === "selectSearch2")) return;
        let newWidth = width;
      setEditFormFields((prevFields = []) => {
        let newFields = [...prevFields];

        if (updatedFormObj.warehouseName) {
          const selectWarehouse = wareHouseSelSearch.find(
            (w) => w.value === updatedFormObj.warehouseName
          );

          newFields = newFields.map((field) => {
            if (field.attribute === "warehouseName") {
              return {
                ...field,
                ...(updatedFormObj.cateringGroup ? { width: `${newWidth + 100}px` } : {}),
                value: selectWarehouse?.value ?? "",
                options: wareHouseSelSearch,
              };
            }
            return field;
          });
        }

        if (updatedFormObj.cateringGroup) {
          const selectedCatGroup = cateringGroupOptions.find(
            (cgt) => cgt.value === updatedFormObj.cateringGroup
          );

          if (sectorsMap.has(updatedFormObj.cateringGroup)) {
            const sectorsCatGrp =
              sectorsMap.get(updatedFormObj.cateringGroup) || [];

            const sectorsList = sectorsCatGrp.map((skt) => ({
              key: skt.id,
              label: `${skt.flightNumber} - ${skt.origin} - ${skt.destination}`,
              value: skt.id,
              date: skt.std,
            }));

            const autoSectorValue =
              updatedFormObj.sector ||
              sectorsList[sectorsList.length - 1]?.value ||
              "";
            const autoFlightDate =
              sectorsList.find((st) => st.value === autoSectorValue)?.date || null;
                  if (selectedCatGroup && selectedCatGroup.value) {
    const labelWidth = calculateTextWidth(selectedCatGroup.label);
    const finalWidth = labelWidth + 100; 
    setwidth(finalWidth); 
    newWidth = finalWidth;
} else {
    setwidth('12.5rem');
    newWidth = 200;
}
            newFields = newFields.map((field) => {
        
              if (field.attribute === "cateringGroup") {
                return {
                  ...field,
                  value: selectedCatGroup?.value ?? "",
                  width:`${newWidth+100}px`,
                  disabled: false,
                };
              }
                   if (field.attribute === "warehouseName") {
              return {
                ...field,
                width:`${newWidth+100}px`,
              };
            }
                       if (field.attribute === "operationDate") {
              return {
                ...field,
                width:`${newWidth+100}px`,
              };
            }

              if (field.attribute === "sector") {
                return {
                  ...field,
                  disabled: false,
                  options: sectorsList,
                  value: autoSectorValue,
                  width:`${newWidth+100}px`,
                  getOptions: () => sectorsList,
                };
              }

              if (field.attribute === "flightDate") {
                return {
                  ...field,
                  value: autoFlightDate ? new Date(autoFlightDate) : "",
                  width:`${newWidth+100}px`,
                  disabled: true,
                };
              }

              return field;
            });
          } else {
            console.log("Catering group not found in sectors map");
          }
        } else {
          newFields = newFields.map((field) => {
            if (field.attribute === "cateringGroup") {
              return { ...field, value: "", disabled: false };
            }
            if (field.attribute === "sector") {
              return { ...field, value: "", options: [], disabled: true };
            }
            if (field.attribute === "flightDate") {
              return { ...field, value: "", disabled: true };
            }
            return field;
          });
        }

        return newFields;
      });
    });
  };

  useEffect(() => {
    if (!updatedFormFieldValues?.operationDate) return;

    let isMounted = true;

    (async () => {
      try {
        const cateringGroupOptns = await loadCateringGroupsByDate(
          updatedFormFieldValues.operationDate
        );

        if (
          isMounted &&
          Array.isArray(cateringGroupOptns) &&
          cateringGroupOptns.length > 0
        ) {
          setEditFormFields((prevFields) => {
            const mergedFields = prevFields.map((field) => {
              if (field.attribute === "cateringGroup") {
                return {
                  ...field,
                  disabled: false,
                  options: cateringGroupOptns,
                  getOptions: () => cateringGroupOptns,
                };
              }
              if (field.attribute === "operationDate") {
                return {
                  ...field,
                  value: new Date(updatedFormFieldValues.operationDate),
                };
              }
              return field;
            });

            if (!mergedFields.length) {
              return AddReconciliationField.map((f) =>
                f.attribute === "cateringGroup"
                  ? {
                      ...f,
                      disabled: false,
                      options: cateringGroupOptns,
                      getOptions: () => cateringGroupOptns,
                    }
                  : f
              );
            }

            return mergedFields;
          });
        }
      } catch (err) {
        console.error("Error while loading catering groups:", err);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [updatedFormFieldValues?.operationDate]);

  async function loadCateringGroupsByDate(value) {
    try {
      setIsLoadingCateringGroupsSelect(true);
      const requestPayload = {
        date: formatDateByTimezone(new Date(value ?? new Date()), false),
      };

      const response = await APIEndpoint.post(
        "operations/rotations/find",
        requestPayload
      );

      if (
        response &&
        Array.isArray(response.rotations) &&
        response.rotations.length > 0
      ) {
        const sectorsLookUp = new Map(
          response.rotations.map((it) => [it.id, it.legs])
        );
        setSectorsMap(sectorsLookUp);

        const cateringGroupOptns = response.rotations.map((ele) => {
          const dte = moment(ele.legs[0]?.std)
            .tz(getCultureFromLs()?.timezone.name)
            .format("DD-MM-YYYY hh:mm A");
          return {
            key: ele.id,
            label: `${ele.tailNumber}/${ele.flightPath}/${dte}`,
            value: ele.id,
          };
        });

        setCateringGroupOptions(cateringGroupOptns);
        return cateringGroupOptns;
      }
      setSectorsMap(new Map());
      setCateringGroupOptions([]);
      return [];
    } catch (error) {
      console.error("loadCateringGroupsByDate error:", error);
      setSectorsMap(new Map());
      setCateringGroupOptions([]);
      return [];
    } finally {
      setIsLoadingCateringGroupsSelect(false);
    }
  }

  React.useEffect(() => {
    fetchStores();
    fetchWarehouse();
    fetchStates();
  }, [ready]);

  React.useEffect(() => {
    if (!filtersRef.current) return;
    storageUtil.set("storeId", storeId, "session");
    const parsedDate = new Date(formatDateByTimezone(date));
    storageUtil.set(
      "date",
      isNaN(parsedDate.getTime()) ? new Date() : parsedDate,
      "session"
    );
    storageUtil.set("reconStateSel", reconStateSel, "session");
    storageUtil.set("wStoreId", wStoreId, "session");
  }, [storeId, date, reconStateSel, wStoreId]);

  const handleReset = () => {
    setState((_) => {
      return { ..._, resetDataSource: !_.resetDataSource };
    });
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setModalFormStatusObj({ text: "" });
      setState((_) => {
        return {
          ..._,
          resetDataSource: !_.resetDataSource,
          selected: false,
          showLoadingApi: false,
        };
      });
    }, 1500);
  };

  const onDateSelect = (e) => {
    filtersRef.current = true;
    setDate(e.target.value);
  };

  const getEffectiveDate = (dateChange) => {
    if (!dateChange) return null;
    if (dateChange !== undefined) {
      let effTime = formatDateByTimezone(new Date(dateChange), false);
      reconStateCreate = {
        ...reconStateCreate,
        date: moment(updatedFormFieldValues.flightDate).format("DD-MM-YYYY"),
      };
      return effTime;
    }
  };

  const fetchStores = async () => {
    if (
      storeArray.length > 0 &&
      storeSelSearch.length > 0 &&
      storesList.length > 0
    )
      return;
    try {
      const resp = await APIEndpoint.get("stores");
      if (resp.result.length > 0) {
        setStoreArray(resp.result);
        const selSearchData = [];
        const options = [{ key: 0, label: preCompile.itemType, value: "" }];
        resp.result.filter((fieldValue, index) => {
          options.push({
            key: fieldValue.id,
            label: `${fieldValue.value}`,
            value: fieldValue.id,
          });
          return fieldValue;
        });
        resp.result.filter((row, index) => {
          selSearchData.push({
            key: index + 1,
            label: row.flightNumber,
            name: row.value,
            value: index + 1,
            origin: row.origin,
            dest: row.destination,
          });
          return row;
        });
        setStoreSelSearch(selSearchData);
        if (!viewOnly) {
          setStoresList(options.slice(1));
        } else if (viewOnly && groupDetails) {
          const { sectors } = groupDetails;
          if (Array.isArray(sectors)) {
            const upliftOptions = options
              .slice(1)
              .filter((option) =>
                groupDetails.sectors?.some(
                  (sector) => sector.key === option.label.replace(/\s+/g, "")
                )
              );
            setStoresList([...upliftOptions]);
            if (sectors.length === 1 && upliftOptions.length === 1) {
              onStoreChange(upliftOptions[0]);
            } else if (sectors.length > 1 && upliftOptions.length > 1) {
              onStoreChange(upliftOptions[0]);
            }
          }
        }
      } else {
        console.log("Log: Error while fetching item types API");
      }
    } catch (error) {}
  };

  const fetchWarehouse = async () => {
    if (
      warehouseArr.length > 0 &&
      wareHouseSelSearch.length > 0 &&
      warehouseArray.length > 0
    )
      return;

    try {
      const resp = await APIEndpoint.get(`warehouses`);
      if (resp.success) {
        const selSearchData = [];
        setWareHouseArr(resp.result);
        const options = [{ key: 0, label: preCompile.warehouses, value: "" }];
        resp.result.filter((fieldValue, index) => {
          options.push({
            key: fieldValue.id,
            label: fieldValue.value,
            value: fieldValue.value,
          });
          return fieldValue;
        });
        resp.result.filter((row, index) => {
          selSearchData.push({
            key: index + 1,
            label: row.value,
            name: `${row.value} (${row.warehouseCode})`,
            value: index + 1,
            whCode: row.warehouseCode,
          });
          return row;
        });
        setWarehouseSelSearch(selSearchData);
        setWareHouseArray(options);
      }
    } catch (error) {}
  };

  const fetchStates = () => {
    const options = [...ReconState];
    setReconstate(options);
  };

  const filterData = {
    action: 4,
    collection: "",
    filterOperation: "or",
    filters: [],
    limit: 50,
    page: 1,
    searchParam: "",
  };

  const fetchReconciliation = async (page = 1, perPage = 50) => {
    if (!viewReconciliations) {
      return { item: [], count: 0 };
    }
    let selArr = [
      { state: reconStateSel },
      { warehouseId: wStoreId },
      { storeId: storeId },
      { flightDate: getEffectiveDate(date) },
    ];
    let latestValues = {};
    selArr.forEach((obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (value !== "") {
          latestValues[key] = value;
        }
      });
    });
    let setNewArr = Object.keys(latestValues).map((key) => ({
      [key]: latestValues[key],
    }));
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    filterData.filters = setNewArr;
    if (filterData.filters.length) {
      try {
        const res = await APIEndpoint.post(
          "manualRecons/listing",
          JSON.stringify(filterData)
        );

        return res;
      } catch (error) {
        console.log(error);
      }
    } else {
      return [];
    }
  };

  const onModalFormInputChange = (e, newFormData) => {
    setModalFormStatusObj({ text: "" });

    if (e !== null) {
      const { name, value } = e.target;
      let newUpdates = modalFormData ? { ...modalFormData } : {};
      newUpdates[name] = value;

      setModalFormData({ ...newFormData });

      if (name === "operationDate") {
        setUpdatedFormFieldValues((prev) => ({
          ...prev,
          operationDate: new Date(value),
        }));
      }
    }
  };

  const onSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const onStoreChange = (e) => {
    setStoreSelect([e]);
    filtersRef.current = true;
    setStoreId(e === null ? "" : e.value);
  };

  const onCreateStoreRecon = (str) => {
    if (storeArray.length) {
      let storeTemp = storeSelSearch.find((s) => {
        return str === s.value;
      });
      let storeSelObj = storeArray.find((i) => {
        return storeTemp?.name === i.value;
      });
      reconStateCreate = { ...reconStateCreate, store: storeSelObj.value };
      return storeSelObj?.id;
    }
  };

  const getWarehouseId = (w) => {
    filtersRef.current = true;
    if (warehouseArr.length && typeof w === "string") {
      let warehouseTemp = wareHouseSelSearch?.find((wr) => {
        return wr?.label === w;
      });
      let warehouseObj = warehouseArr?.find((i) => {
        return i.value === warehouseTemp?.label;
      });
      if (warehouseObj) {
        reconStateCreate = {
          ...reconStateCreate,
          warehouse: warehouseObj.warehouseCode,
        };
        setWStoreId(warehouseObj.id);
        return warehouseObj.id;
      }
    }
    if (warehouseArr.length && Number.isInteger(w)) {
      let warehouseTemp = wareHouseSelSearch.find((wr) => {
        return wr?.value === w;
      });
      let warehouseObj = warehouseArr?.find((i) => {
        return i.value === warehouseTemp?.label;
      });
      if (warehouseObj) {
        reconStateCreate = {
          ...reconStateCreate,
          warehouse: warehouseObj?.warehouseCode,
        };
        setWStoreId(warehouseObj.id);
        return warehouseObj.id;
      }
    }
  };

  const getTransferRow = (rowData) => {
    let row = [];
    EditTransferColumns.forEach(({ attribute, readOnly, type }, i) => {
      let cellVal = { readOnly: readOnly || false, value: "" };
      if (Array.isArray(rowData)) {
        cellVal.value = rowData[i].value;
        cellVal.error = rowData[i].error;
        if (!rowData[i].updated) {
          if (attribute === "itemCode" && rowData[0].value !== "") {
            cellVal.value = items.find(
              (_) => _.itemCode === rowData[0].value
            )?.itemCode;
            cellVal.error = false;
          } else if (attribute === "itemName" && rowData[1].value !== "") {
            cellVal.value = items.find(
              (_) => _.itemName === rowData[1].value
            )?.itemName;
            cellVal.error = false;
          }
        }
      } else {
        cellVal.value = rowData[attribute] || (type === "number" ? 0 : "");
      }

      row.push(cellVal);
    });

    return row;
  };

  const handleSaveTransfer = (rows) => {
    const { editBody } = state;
    setModalFormStatusObj({ text: "" });

    state.dialogData.rows.forEach((items, i) => {
      const matchingItemA1 = rows.find(
        (itemA1) =>
          itemA1[0].value === items.itemCode ||
          itemA1[1].value === items.itemName
      );

      if (matchingItemA1) {
        items.index = i;
        items.actualOffload = parseInt(matchingItemA1[3].value || 0);
        items.wastage = parseInt(matchingItemA1[5].value || 0);
        items.damage = parseInt(matchingItemA1[5].value || 0);
        items.damage = parseInt(matchingItemA1[4].value || 0);
        items.lost = parseInt(matchingItemA1[7].value || 0);
        items.backToWarehouse = parseInt(matchingItemA1[8].value || 0);
      }
    });

    let body = {};
    if (editSheetTitle && editBody) {
      body = {
        flightDate: editBody.flightDate,
        operationDate: editBody.operationDate,
        items: state.dialogData.rows,
        storeId: editBody.storeId,
        warehouseId: editBody.warehouseId,
      };
    }
    if (editSheetTitle && !editBody) {
      body = {
        manualReconId: state.dialogData?.recon?.id,
        items: state.dialogData.rows,
        warehouseId: state.dialogData?.recon?.warehouseId,
      };
    } else {
      body = {
        flightDate: editBody.flightDate,
        operationDate: editBody.operationDate,
        items: state.dialogData.rows,
        storeId: editBody.storeId,
        warehouseId: editBody.warehouseId,
      };
    }

    return APIEndpoint.post("manualRecons/save", body);
  };

  const handleModalCancel = () => {
    const { action } = state.selected;
    setState((_) => ({
      ..._,
      showDialog: "",
      editBody: null,
      selected: false,
      showSheet: false,
      resetDataSource:
        action !== "viewReconciliation"
          ? !_.resetDataSource
          : _.resetDataSource,
    }));
  };

  const handleOnSaveSuccess = (res) => {
    if (state.showDialog === "edit") {
      return handleModalCancel();
    }
    setState((_) => ({
      ..._,
      showSheet: false,
      newTransfer: {
        ..._.newTransfer,
        resetDataSource: !_.resetDataSource,
        message: { text: res.message },
      },
    }));

    let timmerId = setTimeout(() => {
      clearTimeout(timmerId);
      return handleModalCancel();
    }, 750);
  };

  const onCreateReconciliation = () => {
    setModalFormStatusObj({ text: "" });

    setState((_prev) => ({
      ..._prev,
      selected: { action: "newReconciliation" },
      editBody: null,
      newTransfer: null,
    }));

    setModalCustomButtons([
      {
        label: "Add Items",
        attribute: "button",
        type: "button",
        disabled: false,
        className: "submit-button",
        action: "onSubmit",
      },
    ]);

    const today = new Date();

    const updatedEditFields = AddReconciliationField.map((field) => {
      if (
        wareHouseSelSearch.length > 0 &&
        field.attribute === "warehouseName"
      ) {
        return {
          ...field,
          disabled: false,
          options: wareHouseSelSearch,
          getOptions: () => wareHouseSelSearch,
        };
      }

      if (storeSelSearch.length > 1 && field.attribute === "sector") {
        return {
          ...field,
          disabled: false,
          options: storeSelSearch.map((s) => ({ ...s, label: s.name })),
          getOptions: () => storeSelSearch,
        };
      }

      if (field.attribute === "operationDate") {
        return {
          ...field,
          value: today,
          defaultValue: today,
          disabled: false,
        };
      }

      return field;
    });

    setEditFormFields(updatedEditFields);

    setUpdatedFormFieldValues((prev) => ({
      ...prev,
      operationDate: today,
    }));
  };

  const onReconStateSel = (e) => {
    filtersRef.current = true;
    setReconstateSel(e?.value);
  };
  const onWareHouseChange = (e) => {
    if (viewOnly) {
      return;
    } else {
      filtersRef.current = true;
      setWStoreId(e?.value);
      setWarehouseSel(e?.value);
      getWarehouseId(e?.value);
    }
  };

  const onClose = () => {
    setModalFormStatusObj({ text: "" });
    setwidth('12.5rem');
    setState((_prev) => {
      return { ..._prev, selected: false };
    });
  };

  const checkNullKeys = (body) => {
    for (var key in body) {
      if (body["warehouseId"] !== null && body["storeId"] !== null)
        return false;
    }
    return true;
  };
  const onEditSubmit = (e, updated) => {
    let body;
    if (!updated) {
      setModalFormStatusObj({ error: "Please fill all the required fields*" });
      return false;
    }

    if (!updated?.warehouseName) {
      setModalFormStatusObj({ error: "Select a Warehouse!" });
      return false;
    }
    if (!updated?.cateringGroup) {
      setModalFormStatusObj({ error: "Select a Catering Group!" });
      return false;
    }
    if (Boolean(updated)) {
      const storeDetails = editFormFields[3].options
        .find((st) => st.value === editFormFields[3].value)
        ?.label.replace(/\s+/g, "");

      body = {
        operationDate: getEffectiveDate(editFormFields[1].value),
        flightDate: getEffectiveDate(editFormFields[4].value),
        reconId: null,
        warehouseId: getWarehouseId(updated.warehouseName),
        warehouseName:
          wareHouseSelSearch.find((wr) => wr.value === updated.warehouseName)
            ?.label ?? null,
        storeId: storeArray.find((i) => {
          return i?.value.replace(/\s+/g, "") === storeDetails;
        })?.id,
      };

      let payloadCheck = checkNullKeys(body);
      if (!payloadCheck) {
        setState((_prev) => {
          return {
            ..._prev,
            showSheet: true,
            editBody: {
              ...body,
              flightDate: getEffectiveDate(editFormFields[4].value),
            },
          };
        });
        navigate("main/inventory/scan", { state: { reconData: body } });
        // navigate(`reconciliations-create/${body.operationDate}/${body.flightDate}/${body.warehouseId}/${body.storeId}/new/create`);
      }
    }
  };

  const onSubmitReconciliation = async (row) => {
    const { id, warehouseId } = state.selected?.data ?? row;

    try {
      setState((_prev) => {
        return { ..._prev, showLoadingApi: true };
      });
      const resp = await APIEndpoint.post(
        `warehouses/${warehouseId}/manualRecons/finalize/${id}`
      );
      if (resp) {
        setModalFormStatusObj({ text: resp.message });
        handleReset();
      }
    } catch (error) {
      setModalFormStatusObj({ text: error.resp.message });
    }
  };
  const enableButtons = (submitBtnObj, cancelButtonObj) => {
    submitBtnObj?.removeAttribute("disabled");
    cancelButtonObj?.removeAttribute("disabled");
  };

  const onEnableDisableAction = async (dec = null, data) => {
    if (!data) {
      return;
    }
    const payload = {
      event: dec,
    };
    const submitBtnObj = document.getElementsByClassName("done-button")[0];
    const cancelButtonObj = document.getElementsByClassName("cancel-button")[0];

    submitBtnObj?.setAttribute("disabled", "true");
    cancelButtonObj?.setAttribute("disabled", "true");

    try {
      const res = await APIEndpoint.post(
        `manualRecons/${data.id}/events`,
        payload
      );
      if (res && res.success) {
        setModalFormStatusObj({ text: res.msg || "Review requested" });
        setTimeout(() => {
          enableButtons(submitBtnObj, cancelButtonObj);
        }, 1800);
        handleReset();
      }
    } catch (error) {
      let { data } = JSON.parse(error.message);
      setModalFormStatusObj({
        error: data?.msg || "Failed to send review request",
      });
      setTimeout(() => {
        enableButtons(submitBtnObj, cancelButtonObj);
      }, 1800);
    }
  };

  const onAction = async (e, action, row) => {
    if (action.value === "Edit Reconciliation" && editReconciliations) {
      navigate(`reconciliations-create/${row.operationDate}/${row.flightDate}/${row.warehouseId}/${row.storeId}/${row.id}/editReconciliation`);
    }
    if (action.value === "reviewRequested") {
      setModalTitle(t("pages.inventoryContent.uplifts.requestConfirmation"));
      updatedEditFields = [
        {
          label: "Request confirmation of retrieval from warehouse officer.",
          attribute: "alertMessage",
          type: "alertMessage",
        },
      ];
      setModalCustomButtons([
        {
          label: "Request Confirmation",
          attribute: "button",
          type: "button",
          disabled: false,
          className: "submit-button",
          action: () => onEnableDisableAction("reviewRequested", row),
        },
      ]);
      setState((_prev) => {
        return { ..._prev, selected: { ...row, action: action } };
      });
      setEditFieldsCess(updatedEditFields);
      setState((_prev) => {
        return {
          ..._prev,
          selected: { ...row, ...updatedEditFields[0], action: action },
        };
      });
    }
    if (action.value === "requestWarehouseOfficerReview") {
      setModalTitle(t("pages.inventoryContent.uplifts.reviewRetrieval"));
      updatedEditFields = [
        {
          label: "Approve or reject retrieval plan.",
          attribute: "alertMessage",
          type: "alertMessage",
        },
      ];
      setModalCustomButtons([
        {
          label: "Approve",
          attribute: "button",
          type: "button",
          disabled: false,
          className: "submit-button",
          action: () => onEnableDisableAction("approved", row),
        },
        {
          label: "Reject",
          attribute: "button",
          type: "button",
          disabled: false,
          className: "cancel-button",
          action: () => onEnableDisableAction("rejected", row),
        },
      ]);
      setState((_prev) => {
        return { ..._prev, selected: { ...row, action: action } };
      });
      setEditFieldsCess(updatedEditFields);
      setState((_prev) => {
        return {
          ..._prev,
          selected: { ...row, ...updatedEditFields[0], action: action },
        };
      });
    }

    if (action.value === "awaitCatManagerConfirmation") {
      setModalTitle(t("pages.inventoryContent.uplifts.sendConfirmation"));
      updatedEditFields = [
        {
          label:
            "Submitting a retrieval is irreversible. Make sure that everything is in order before proceeding.",
          attribute: "alertMessage",
          type: "alertMessage",
        },
      ];
      setModalCustomButtons([
        {
          label: "Finalize",
          attribute: "button",
          type: "button",
          disabled: false,
          className: "submit-button",
          action: () => onSubmitReconciliation(row),
        },
        {
          label: "Reject",
          attribute: "button",
          type: "button",
          disabled: false,
          className: "cancel-button",
          action: () => onEnableDisableAction("rejected", row),
        },
      ]);
      setState((_prev) => {
        return { ..._prev, selected: { ...row, action: action } };
      });
      setEditFieldsCess(updatedEditFields);
      setState((_prev) => {
        return {
          ..._prev,
          selected: { ...row, ...updatedEditFields[0], action: action },
        };
      });
    }
    if (action.value === "ScanInventory") {
      let body = {
        operationDate: getEffectiveDate(row?.operationDate),
        flightDate: getEffectiveDate(row?.flightDate),
        reconId: row.id,
        warehouseId: getWarehouseId(row?.warehouseId),
        warehouseName: row.warehouseName ?? null,
        storeId: row?.storeId,
      };
      navigate("main/inventory/scan", { state: { reconData: body } });
    }

    if (action.value === "Submit Reconciliation" && saveReconciliation) {
      setState((_prev) => {
        return {
          ..._prev,
          selected: { action: "Submit Reconciliation", data: row },
        };
      });
    }

    if (action.value === "Delete Reconciliation" && deleteReconciliation) {
      setState((_prev) => {
        return {
          ..._prev,
          selected: { action: "Delete Reconciliation", data: row },
        };
      });
    }
    if (action.value === "View Reconciliation" && viewReconciliations) {
      const { warehouseId, id } = row;
      try {
        const resp = await APIEndpoint.get(
          `warehouses/${warehouseId}/manualRecons/${id}`
        );
        setState((_prev) => {
          return {
            ..._prev,
            selected: {
              action: "viewReconciliation",
              data: resp.manualRecon || {},
            },
          };
        });
      } catch (error) {}
    }
  };

  const onDownloadMaster = () => {
    setShowDownloadModal(true)
  };

  const onCloseDownloadModal = () => {
    setShowDownloadModal(false)
  };

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
        <div className="flexRow justifyContentSpaceBetween alignItemsCenter">
          <div className="flexRow gap10 width100 margTop8 margBot10  justifyContentFlexStart alignItemsCenter">
            <div className="flexRow justifyContentFlexEnd alignItemsBaseline">
              <button className="saleType-div m-2">
                <CustomSelect
                  options={warehouseArray}
                  placeHolder="Search Warehouse"
                  disabled={!viewOnly ? false : true}
                  value={
                    warehouseArray?.filter(
                      (option) => option?.key === wStoreId
                    ) || []
                  }
                  onChange={onWareHouseChange}
                />
              </button>
              {storeSelect ? (
                <div
                  className="orderBy-div m-2 margLeft"
                  style={{ marginBottom: "0.3rem" }}
                >
                  <Select
                    options={storesList}
                    defaultValue={
                      storeSelect[0]?.label ? storeSelect[0]?.label : ""
                    }
                    value={storesList?.filter(function (option) {
                      return storeSelect.length && storeSelect[0]
                        ? storeSelect.find((sc) => sc.label === option.label)
                        : option.key === storeId;
                    })}
                    onChange={onStoreChange}
                    styles={customSelSearch(themedColor)}
                    placeholder="Search Sector"
                    isSearchable
                    isClearable
                    className="selectMenu-meals"
                  />
                </div>
              ) : (
                <></>
              )}

              <button className="saleType-div m-2">
                {!viewOnly ? (
                  <CustomSelect
                    options={reconState}
                    placeHolder="Search State"
                    value={
                      reconState?.filter(
                        (option) => option?.value === reconStateSel
                      ) || []
                    }
                    onChange={onReconStateSel}
                  />
                ) : null}
              </button>

              <div className={`dialog__description`}>
                <NGODatePicker
                  isClearable={false}
                  value={date}
                  minDate={dateRange.minDate || null}
                  maxDate={dateRange.maxDate || null}
                  style={{ width: "7rem", border: "1.48px solid #fff" }}
                  placeholder={t("effectiveDate")}
                  placeholdertext={t("datePickerPlaceholder")}
                  onChange={onDateSelect}
                />
              </div>
            </div>
            {!viewOnly ? (
              <div className="flexRow alignItemsCenter margBot10 margTop8 underline">
                
                <span>
                  <img
                    className="icon-size margTop8"
                    alt={t("filters.searchText")}
                    src={searchIcon}
                  />
                </span>
                <span>
                  <input
                    className="search"
                    onChange={onSearch}
                    type="search"
                    placeholder={t("filters.searchText")}
                    value={searchKey}
                  />
                </span>
              </div>
            ) : (
              <></>
            )}
            {/* Download enabled only if the user have permission to download the retrieval variance report */}
            {downloadRetrievalVarianceReport ? (
              <button onClick={onDownloadMaster} style={{marginLeft: "auto", marginRight: "0.5rem"}}>
                <img
                  className="icon-size-min"
                  alt={t("filters.searchText")}
                  src={downloadMasterIcon}
                />
              </button>
            ) : (
              <></>
            )}
       
          </div>
          {createReconciliation && !viewOnly ? (
              <div className="flexRow justifyContentFlexEnd">
                <button
                  className="add-item-button"
                  onClick={onCreateReconciliation}
                >
                  {t("buttons.create")}
                </button>
              </div>
            ) : (
              <></>
            )}
            </div>
          <DataGrid
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            gridReset={gridReset}
            storeId={storeId}
            date={date}
            reconStateSel={reconStateSel}
            warehouseId={wStoreId}
            onCreateReconciliation={() => onCreateReconciliation()}
            resetDataSource={state.resetDataSource}
            getRows={fetchReconciliation}
            noResultsMessage={"No Data"}
            rowSelection="multiple"
            columnResize={true}
          />
        </>
      }
      {state &&
        Boolean(state.selected) &&
        state.selected.action === "editReconciliation" && (
          <SpreadsheetModal
            showDone={false}
            isSubModal={state.showDialog === "add"}
            columns={EditTransferColumns.map((_) => {
              return { ..._, options: items };
            })}
            getRow={getTransferRow}
            data={state.dialogData ? state.dialogData.rows : null}
            save={handleSaveTransfer}
            onSave={handleOnSaveSuccess}
            onClose={handleModalCancel}
            title={`Edit Reconciliation - ${editSheetTitle}`}
            darkMode={true}
          />
        )}

{state &&
  Boolean(state.selected) &&
  state.selected.action === "viewReconciliation" && (
    <Modal
      className="cash-deposit-summary"
      title={``}
      TitleComponent={sectorTitle}
      onSubmit={handleModalCancel}
      onClose={handleModalCancel}
      overlayClassName={'overlay-e1'}
      customModalStyle={{ width: '91.5%' }}
    >
      <DataGrid
        rowData={
          state.selected.data && (state.selected.data?.items || [])
        }
        columnResize
        ref={tableRef}
        className="full-flex"
        showDefaultFilters={false}
        enableGridSearch={false}
        columns={RecocniliationView}
        rowModelType="clientSide"
      />
    </Modal>
  )}

      {state &&
      Boolean(state.selected) &&
      (state.selected?.action.value === "reviewRequested" ||
        state.selected.action.value === "requestWarehouseOfficerReview" ||
        state.selected.action.value === "awaitCatManagerConfirmation") ? (
        <div className="flexRow width100">
          <EditModal
            key={state.selected.action}
            title={modalTitle}
            onClose={onClose}
            mainContentCenter={true}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onEnableDisableAction}
            modalCustomButtons={modalCustomButtons}
            fields={EditFieldsCess.map((elt) => {
              return { ...elt, initialValue: state.selected[elt.attribute] };
            })}
          />
        </div>
      ) : null}
      {state &&
        Boolean(state.selected) &&
        state.selected.action === "newReconciliation" && (
          <EditModal
            title={"New Retrieval"}
            onClose={onClose}
            onSubmit={onEditSubmit}
            modalCustomButtons={modalCustomButtons}
            modalFormStatusObj={modalFormStatusObj}
            fields={editFormFields.map((_) => {
              if (_.attribute === "cateringGroup") {
                return {
                  ..._,
                  optionsLoading: isLoadingCateringGroupsSelect,
                  initialValue: "",
                };
              }
              return { ..._, initialValue: "" };
            })}
            onChange={(e, updated) => {
              setUpdatedFormFieldValues(updated);
              if (Number.isInteger(e)) {
                // Search select
                updateEditFormValues(e, updated);
              }
              if (!e) {
                // Search select2
                updateEditFormValues(e, updated, "selectSearch2");
              } else {
                onModalFormInputChange(e, updated);
              }
            }}
            showFieldsInColumn={true}
          />
        )}

      {Boolean(state?.selected) &&
        state.selected.data &&
        state.selected.action === "Submit Reconciliation" && (
          <ConfirmModal
            title={`Submit Retrieval -${state.selected.data?.code}`}
            description={
              "Submitting a retrieval is irreversible. Make sure that everything is in order before proceeding."
            }
            onSubmit={onSubmitReconciliation}
            showLoadingApi={state.showLoadingApi}
            modalFormStatusObj={modalFormStatusObj}
            fields={emptyFields}
            onClose={onClose}
          />
        )}
      {!ready && <div className="overlay_hide sub"></div>}
      {showDownloadModal && <RetrievalVarianceReportDownload onClose={onCloseDownloadModal} />}
      <ToastContainer />
        <RetrievalImportErrorModal
        open={retrievalImportError.open}
        errors={retrievalImportError.errors}
        message={retrievalImportError.message}
        onClose={() => setRetrievalImportError({ open: false, errors: [], message: "" })}
        />
    </div>
  );
};
